/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import { FE_VIEW_ARTIFACT_STORAGE, UPLOAD_ARTIFACT_STORAGE_FILES } from 'domain/shared/artifactStorage';
import ArtifactStorageList from 'domain/documents/artifactStorage/List';
import { CreateArtifact } from 'domain/documents/artifactStorage/createupdate';
import { createRoute, Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';
import ViewArtifactStorageFile from 'domain/documents/artifactStorage/Show';
import ArtifactStorageFileContext from 'domain/documents/artifactStorage/shared/ArtifactStorageFileContext';
import { ARTIFACT_STORAGE_PATH } from 'domain/shared/artifactStorage';

const useArtifactStorageRoute = () => {
  return createRoute({
    listRoute: ARTIFACT_STORAGE_PATH,
    singleEntityRoute: `/file/:fileId`,
  });
};

const ArtifactStorageRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute, createRoute: createArtifactRoute, singleEntityRoute } = useArtifactStorageRoute();

  return (
    <ProtectedRouter basePath={ARTIFACT_STORAGE_PATH}>
      <Routes>
        <Route
          path={createArtifactRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={UPLOAD_ARTIFACT_STORAGE_FILES}>
              <CreateArtifact />
            </GlobalProtectedRoute>
          }
        />
        <Route
          path={singleEntityRoute}
          element={
            <ArtifactStorageFileContext permissionToCheck={FE_VIEW_ARTIFACT_STORAGE}>
              <ViewArtifactStorageFile />
            </ArtifactStorageFileContext>
          }
        />

        <Route
          path={`${listRoute}/*`}
          element={
            <GlobalProtectedRoute path={listRoute} globalPermissionToCheck={FE_VIEW_ARTIFACT_STORAGE}>
              <ArtifactStorageList />
            </GlobalProtectedRoute>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

ArtifactStorageRouter.getRouterPath = () => `${ARTIFACT_STORAGE_PATH}/*`;

export default ArtifactStorageRouter;
